import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchPodDates,
  insertPodDate,
} from "../../../services/logisticService";

export const insertPodDateThunk = createAsyncThunk(
  "logistics/insertPodDate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await insertPodDate(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchPodDatesThunk = createAsyncThunk(
  "logistics/fetchPodDates",
  async (params, { rejectWithValue }) => {
    try {
      const response = await fetchPodDates(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
